/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ReactComponent as UserIcon } from '../../../../assets/svg/company-icon/user-lite.svg';

const CompanyEmployeeCount = props => {
  const { employeeCount = '', parentClass = '', clsName = '' } = props;

  return employeeCount !== undefined &&
    employeeCount !== '' &&
    employeeCount !== null ? (
    <div className={`company-empcount icon-wrap ${parentClass}`}>
      <UserIcon className="svg-icon" />
      <div
        className={`item-name show-elipsis ${clsName}`}
        title={employeeCount}
      >
        {employeeCount}
      </div>
    </div>
  ) : (
    ''
  );
};

export { CompanyEmployeeCount };
export default CompanyEmployeeCount;
